import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './stores/auth';

const app = createApp(App);
app.use(createPinia());
app.use(router);

// Atstatyti vartotojo sesiją iš localStorage
const auth = useAuthStore();
auth.fetchMe().finally(() => {
  app.mount('#app');
});
